export enum OptionInputTypes {
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
}

export enum OptionInputStyles {
  CHECKBOX = 'checkbox',
  HIDDEN = 'hidden',
  RADIO = 'radio',
}
